<template>
  <div class="page-title">
    <div class="container">
      <ul class="nav">
        <li class="nav-item border-left-0">
          <a class="nav-link" @click="goHome()">
            <img src="~../../assets/image/icon/home.png" height="40" />
          </a>
        </li>
        <li class="nav-item text-left border-right-0">
          <template v-for="(navItem, index) in navItems">
            <span :class="{ 'step': true, 'active': step === index, 'past': step > index }">{{ navItem }}</span>
            <img src="~../../assets/image/icon/step_arrow.png" v-if="index < navItems.length - 1" />
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {

  name: 'StepTitle',

  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    },

    index: {
      type: Number,
      required: true,
      default: 1
    },

    step: {
      type: Number,
      required: true,
      default: 1
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/color.scss';

span.step {
  margin-right: 1em;
  margin-left: 1em;
  color: #ccc;

  &.active {
    color: $main-color;
  }

  &.past {
    color: #000;
  }
}
</style>


// WEBPACK FOOTER //
// StepTitle.vue?c35f3c5c